import type { QuoteRestriction } from "@freightsimple/generated-dashboard-openapi-client/models/QuoteRestriction";
import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import LocationsDockHoursInput from "./LocationsDockHoursInput";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import { buildHoursOptions } from "../Helpers/locationsHoursOptions";
import { getRestrictionViolation } from "../Helpers/locationsHoursOptions";

interface RestrictedDockHoursInputProps {
  openFrom: string;
  openUntil: string;
  setOpenFrom: (_: string) => void;
  setOpenUntil: (_: string) => void;
  context: LocationContext;
  restrictions: QuoteRestriction[] | undefined;
  pickupOpenUntil: string | undefined;
  hoursErrorMessage: ErrorMessageType;
  warningMessage?: ErrorMessageType | undefined;
  forceValidation: boolean;
}

export function LocationsRestrictedDockHoursInput(
  props: RestrictedDockHoursInputProps,
) {
  const openFromOptions = buildHoursOptions(
    props.context,
    "openFrom",
    props.restrictions,
    props.pickupOpenUntil,
  );

  const openUntilOptions = buildHoursOptions(
    props.context,
    "openUntil",
    props.restrictions,
    props.pickupOpenUntil,
  );

  const isPickup = props.context === LocationContext.Pickup;
  const selectedValue = isPickup ? props.openFrom : props.openUntil;
  const selectedField = isPickup ? "openFrom" : "openUntil";

  const restrictionError =
    props.restrictions && props.restrictions.length > 0
      ? getRestrictionViolation(
          selectedValue,
          props.context,
          selectedField,
          props.restrictions,
          props.pickupOpenUntil,
        )
      : undefined;

  const errorMessage = restrictionError ?? props.hoursErrorMessage;

  return (
    <LocationsDockHoursInput
      openFrom={props.openFrom}
      openUntil={props.openUntil}
      setOpenFrom={props.setOpenFrom}
      setOpenUntil={props.setOpenUntil}
      openFromOptions={openFromOptions}
      openUntilOptions={openUntilOptions}
      errorMessage={errorMessage}
      warningMessage={props.warningMessage}
      forceValidation={props.forceValidation}
    />
  );
}
